import React, { useMemo } from 'react';
import s from './s.module.less';
import { Button } from 'antd';
import { RightOutlined, LeftOutlined } from '@ant-design/icons';

interface bannerConfig {
    title: string;
    desc?: string;
    btnText?: string;
    btnClick: () => void;
}

interface StepBannerProps {
    bannerConfig: bannerConfig[];
    type: 'info' | 'warning';
}

const StepBanner: React.FC<StepBannerProps> = ({
    bannerConfig,
    type = 'info',
}) => {
    const [bannerIndex, setBannerIndex] = React.useState(0);

    if (bannerConfig.length === 0) {
        return null;
    }

    const icon = useMemo(() => {
        if (type === 'info') {
            return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM11 6C11 6.55228 10.5523 7 10 7C9.44772 7 9 6.55228 9 6C9 5.44772 9.44772 5 10 5C10.5523 5 11 5.44772 11 6ZM9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11V14C9 14.5523 9.44772 15 10 15H11C11.5523 15 12 14.5523 12 14C12 13.4477 11.5523 13 11 13V10C11 9.44772 10.5523 9 10 9H9Z" fill="#60A5FA" />
            </svg>
        } else if (type === 'warning') {
            return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M8.25706 3.0976C9.02167 1.7383 10.9788 1.7383 11.7434 3.0976L17.3237 13.0181C18.0736 14.3514 17.1102 15.9987 15.5805 15.9987H4.4199C2.89025 15.9987 1.92682 14.3514 2.67675 13.0181L8.25706 3.0976ZM11.0001 12.9988C11.0001 13.5511 10.5524 13.9988 10.0001 13.9988C9.44784 13.9988 9.00012 13.5511 9.00012 12.9988C9.00012 12.4465 9.44784 11.9988 10.0001 11.9988C10.5524 11.9988 11.0001 12.4465 11.0001 12.9988ZM10.0001 4.99878C9.44784 4.99878 9.00012 5.44649 9.00012 5.99878V8.99878C9.00012 9.55106 9.44784 9.99878 10.0001 9.99878C10.5524 9.99878 11.0001 9.55106 11.0001 8.99878V5.99878C11.0001 5.44649 10.5524 4.99878 10.0001 4.99878Z" fill="#FBBF24" />
            </svg>;
        };
    }, [type]);

    return (
        <div className={`${s.combinedWrap} ${s[type]}`}>
            <div className={s.content}>
                <div className={s.leftSection}>
                    <div className={s.tipIcon}>
                        {icon}
                    </div>
                    <div className={s.text}>
                        <div className={s.webinarSection}>
                            <div className={s.tipTitle}>{bannerConfig[bannerIndex]?.title}</div>
                            {bannerConfig[bannerIndex]?.desc && <div className={s.tipDesc}>{bannerConfig[bannerIndex]?.desc}</div>}
                        </div>
                        {bannerConfig[bannerIndex]?.btnText && <Button className={s.button} onClick={bannerConfig[bannerIndex]?.btnClick}>
                            {bannerConfig[bannerIndex]?.btnText}
                        </Button>}
                    </div>
                </div>
                {bannerConfig.length > 1 ?
                    <div className={s.rightSection}>
                        <span className="mr-3 font-semibold">{`${bannerIndex + 1} / ${bannerConfig.length}`}</span>
                        {bannerIndex < bannerConfig.length - 1
                            ? <span onClick={() => setBannerIndex((index) => index + 1)}> <RightOutlined /> </span>
                            : <span onClick={() => setBannerIndex((index) => index - 1)}><LeftOutlined /></span>}
                    </div> : null}
            </div>
        </div>
    );
};

export default StepBanner;
